export function logoutUsecaseFactory(deps) {
    return deps.authRepository.doLogout;
}
//# sourceMappingURL=logout.usecase.js.map